<template>
  <section v-if="channelUrl" class="hub-channel">
    <a :href="channelUrl" target="_blank" rel="noopener" class="hub-channel__card">
      <span class="hub-channel__icon">
        <TelegramLineIcon :size="38" color="#FFFFFF" />
      </span>
      <span class="hub-channel__text">
        <span class="hub-channel__title" v-html="getTitleBlock(page, 'channel', 'title')"></span>
        <span class="hub-channel__description" v-html="getTitleBlock(page, 'channel', 'description')"></span>
      </span>
      <span class="hub-channel__button">
        {{ getKeyValueListBlockValue(page, 'channel-details', 'button') }}
        <span class="hub-channel__button-dot">
          <ChevronRightLineIcon :size="16" color="#6171E4" />
        </span>
      </span>
    </a>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';
import { Env } from '@/shared/config/environment';
import { ChevronRightLineIcon, TelegramLineIcon } from '@/shared/ui/icons';

export default {
  mixins: [ textBlock ],
  components: { TelegramLineIcon, ChevronRightLineIcon },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
      channelUrl: Env.telegram.agentsChannelUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.hub-channel {
  max-width: 1328px;
  margin: 0 auto;
  padding: 120px 24px 0;

  @media (max-width: 800px) {
    padding: 72px 16px 0;
  }

  &__card {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px 32px;
    padding: 40px;
    border-radius: 28px;
    background: #CBDDFA;
    color: #373A3D;
    text-decoration: none;

    @media (max-width: 800px) {
      padding: 24px;
    }
  }

  &__icon {
    flex: none;
    width: 80px;
    height: 80px;
    border-radius: 999px;
    background: #6171E4;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    flex: 1 1 360px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__title {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(28px, 3vw, 40px);
    line-height: 1.2;
  }

  &__description {
    font-size: 18px;
    line-height: 26px;
    color: #4E5358;
  }

  &__button {
    flex: none;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    height: 56px;
    padding: 0 8px 0 24px;
    border-radius: 12px;
    background: #6171E4;
    color: #FFFFFF;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 17px;
    transition: background-color 0.2s;

    @media (max-width: 800px) {
      flex: 1 1 100%;
      justify-content: space-between;
    }
  }

  &__card:hover &__button {
    background: #4555CC;
  }

  &__button-dot {
    width: 38px;
    height: 38px;
    border-radius: 999px;
    background: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
